<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
            <el-breadcrumb-item
                :to="{
                    path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management',
                }"
                >个人赛赛务工具</el-breadcrumb-item
            >
            <el-breadcrumb-item
                :to="{
                    path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_room_list',
                }"
                >线下选考场</el-breadcrumb-item
            >
            <el-breadcrumb-item>选手管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <!-- 轮次切换tab -->
        <el-card style="margin-top: 15px">
            <el-tabs
                v-model="activeRound"
                @tab-click="handleTabClick"
                type="card"
                class="round-tabs"
            >
                <el-tab-pane label="选手管理" name="0">
                    <span slot="label">
                        <i class="el-icon-user"></i>
                        选手管理
                    </span>
                </el-tab-pane>
                <el-tab-pane label="第一轮:小程序答题" name="1">
                    <span slot="label">
                        <i class="el-icon-first-aid-kit"></i>
                        第一轮:小程序答题
                    </span>
                </el-tab-pane>
                <el-tab-pane label="第二轮:小程序答题" name="2">
                    <span slot="label">
                        <i class="el-icon-medal"></i>
                        第二轮:小程序答题
                    </span>
                </el-tab-pane>
                <el-tab-pane label="第三轮:上台平板答题" name="3">
                    <span slot="label">
                        <i class="el-icon-trophy"></i>
                        第三轮:上台平板答题
                    </span>
                </el-tab-pane>
                <el-tab-pane label="第四轮:上台口拼答题" name="4">
                    <span slot="label">
                        <i class="el-icon-trophy"></i>
                        第四轮:上台口拼答题
                    </span>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <!-- 考场筛选 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">选手筛选</span>
                </el-col>
            </el-row>
            <el-form
                :model="queryForm"
                class="filter_Form"
                label-width="90px"
                ref="queryFormRef"
            >
                <el-row :gutter="50">
                    <el-col :span="6">
                        <el-form-item label="姓名" prop="userName">
                            <el-input
                                v-model="queryForm.userName"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="联系方式" prop="phone">
                            <el-input
                                v-model="queryForm.phone"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                      <el-col :span="6">
                        <el-form-item label="学校名称" prop="schoolName">
                            <el-input
                                v-model="queryForm.schoolName"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="activeRound === '0'">
                        <el-form-item label="是否签到" prop="sign">
                            <el-select
                                v-model="queryForm.sign"
                                placeholder="请选择"
                                clearable
                                style="width: 100%"
                            >
                                <el-option label="已签到" :value="1"></el-option>
                                <el-option label="未签到" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="activeRound !== '0'">

                    </el-col>
                </el-row>

                <el-row v-if="activeRound !== '0'">
                    <el-col :span="24">
                        <el-checkbox
                            v-model="queryForm.scoreValid"
                            @change="checkChange"
                            >只查询成绩有效的数据(按分数降序排序)</el-checkbox
                        >
                    </el-col>
                </el-row>
            </el-form>
            <el-row :gutter="20" type="flex" justify="end">
                <el-col :span="2">
                    <el-button
                        type="primary"
                        style="width: 100%"
                        @click="handleToSearch"
                        >查询</el-button
                    >
                </el-col>
                <el-col :span="2">
                    <el-button
                        type="primary"
                        plain
                        style="width: 100%"
                        @click="handleToReset"
                        >重置</el-button
                    >
                </el-col>
            </el-row>
        </el-card>
        <!-- 考场管理 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col :span="6">
                    <span class="title_class">选手管理</span>
                </el-col>
                <el-col :span="18">
                    <div class="div_algin_right">
                        <!-- 手机号添加选手 -->
                        <el-button
                            v-if="activeRound === '0'"
                            type="primary"
                            plain
                            @click="showPhoneAddDialog"
                            >手机号添加考生</el-button
                        >
                         <el-button
                            v-if="activeRound !== '0'"
                            type="primary"
                            plain
                            @click="getExamQuestion"
                            >获取考题</el-button
                        >
                        <el-button
                            v-if="activeRound !== '0'"
                            type="primary"
                            plain
                            @click="turnToDetails"
                            >前往裁判系统</el-button
                        >
                        <el-button
                            v-if="activeRound !== '0'"
                            type="primary"
                            plain
                            @click="showMaskFn"
                            >批量设置晋级</el-button
                        >
                        <el-button
                            v-if="activeRound === '0'"
                            type="primary"
                            plain
                            icon="el-icon-refresh-right"
                            @click="resetAllFn"
                            >全部重置</el-button
                        >
                        <el-button
                            v-if="activeRound === '0'"
                            type="primary"
                            @click="showStudents"
                            >添加考生</el-button
                        >
                        <el-button
                            type="primary"
                            plain
                            icon="el-icon-download"
                            @click="exportTable()"
                            >导出考生</el-button
                        >
                    </div>
                </el-col>
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="dataList"
                border
                stripe
            >
                <el-table-column
                    label="序号"
                    type="index"
                    width="50px"
                ></el-table-column>
                <el-table-column label="准考证号" prop="examinationNumber">
                    <template slot-scope="{ row }">
                        {{ row.examinationNumber || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" prop="examinationUserName">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserName || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="手机号" prop="examinationUserPhone">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserPhone || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="邮箱" prop="examinationUserEmail">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserEmail || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="学校" prop="examinationUserSchoolName">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserSchoolName || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="年级"
                    prop="examinationUserGrade"
                    :formatter="gradeFormat"
                ></el-table-column>
                <el-table-column
                    label="组别"
                    prop="examinationUserLevel"
                    :formatter="levelFormat"
                ></el-table-column>
                <el-table-column v-if="isShowScore" label="本轮分数" prop="score">
                     <template slot-scope="scope">
                         {{ scope.row.score ?? "-" }}
                     </template>
                 </el-table-column>
                           <el-table-column label="总分(1+2轮)" prop="totalScore" v-if="activeRound === '2'">
                    <template slot-scope="scope">
                        {{ scope.row.totalScore ?? "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="总分(1+2+3轮)" prop="totalScore" v-if="activeRound === '3'">
                    <template slot-scope="scope">
                        {{ scope.row.totalScore ?? "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="总分(1+2+3+4轮)" prop="totalScore" v-if="activeRound === '4'">
                    <template slot-scope="scope">
                        {{ scope.row.totalScore ?? "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="签到状态" width="100px" v-if="activeRound === '0'">
                    <template slot-scope="{ row }">
                        <el-switch
                            v-model="row.sign"
                            @change="handleSignChange(row)"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                        >
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column v-if="activeRound === '0'" label="国赛晋级状态" prop="promotion">
                    <template slot-scope="scope">
                        <el-tag
                            type="danger"
                            v-if="scope.row.promotion === 2"
                            size="mini"
                            >未晋级</el-tag
                        >
                        <el-tag
                            type="success"
                            v-else-if="scope.row.promotion === 1"
                            size="mini"
                            >晋级</el-tag
                        >
                        <el-tag
                            type="warning"
                            v-else-if="
                                !scope.row.promotion ||
                                scope.row.promotion === 0
                            "
                            size="mini"
                            >未设置</el-tag
                        >
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="activeRound !== '0'"
                    label="晋级状态"
                    width="120px"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-tag
                            type="danger"
                            v-if="getCurrentRoundPromotion(scope.row) === 2"
                            size="mini"
                            >未晋级</el-tag
                        >
                        <el-tag
                            type="success"
                            v-else-if="
                                getCurrentRoundPromotion(scope.row) === 1
                            "
                            size="mini"
                            >晋级</el-tag
                        >
                        <el-tag
                            type="warning"
                            v-else-if="
                                !getCurrentRoundPromotion(scope.row) ||
                                getCurrentRoundPromotion(scope.row) === 0
                            "
                            size="mini"
                            >未设置</el-tag
                        >
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="180px">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            v-if="activeRound === '0'"
                            size="small"
                            style="margin-right: 12px"
                            @click="showEditDialog(scope.row)"
                            >移出考场</el-button
                        >
                        <el-button
                            v-if="activeRound === '0'"
                            type="text"
                            size="small"
                            style="margin-right: 12px"
                            @click="scoreEditDialog(scope.row)"
                            >设置国赛晋级</el-button
                        >
                                                 <el-button
                             v-if="activeRound !== '0'"
                             type="text"
                             size="small"
                             @click="scoreRoundEditDialog(scope.row)"
                             >设置轮次晋级</el-button
                         >
                         <el-button
                            type="text"
                            v-if="activeRound !== '0' && activeRound !== '4'"
                            size="small"
                            style="margin-right: 12px"
                            @click="turnAnswerResult(scope.row)"
                            >答题详情</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </el-card>
        <!-- 修改线上成绩的dialog -->
        <el-dialog
            title="修改成绩信息"
            :visible.sync="editScoreDialogVisible"
            @close="editScoreDialogClose"
            width="30%"
        >
            <el-form
                :model="editScoreForm"
                label-width="80px"
                ref="editScoreFormRef"
                :rules="editScoreFormRules"
            >
                <el-form-item label="姓名" prop="examinationUserName">
                    <el-input
                        v-model="editScoreForm.examinationUserName"
                        placeholder="请输入"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="晋级资格" prop="promotion">
                    <el-radio-group v-model="editScoreForm.promotion">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editScoreDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="savePromotionInfoData"
                    >修 改</el-button
                >
            </span>
        </el-dialog>
        <!-- 添加考生 -->
        <el-dialog
            title="添加考生"
            :visible.sync="stuVisible"
            width="70%"
            @close="handleCloseDialog"
        >
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="stuList"
                border
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                    label="序号"
                    type="index"
                    width="50px"
                ></el-table-column>
                <el-table-column label="姓名" prop="userName"></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <el-table-column
                    label="学校"
                    prop="schoolName"
                ></el-table-column>
                <el-table-column
                    label="年级"
                    prop="grade"
                    :formatter="gradeFormat"
                ></el-table-column>
                <el-table-column
                    label="组别"
                    prop="enrollmentLevel"
                    :formatter="levelFormat"
                ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleToAdd">添 加</el-button>
            </span>
        </el-dialog>
        <!-- 批量设置晋级 -->
        <el-dialog
            title="批量设置晋级"
            :visible.sync="visible"
            width="560px"
            @close="handleCloseDialogSet"
        >
            <div style="text-align: left">
                <span style="margin-right: 12px; margin-left: 28px">设置成绩为</span>
                <el-input-number v-model="score" :min="0" style="text-align: left"></el-input-number>
                <span style="margin-left: 12px">分及以上的选手晋级</span>
            </div>
            <div style="text-align: left; margin-top: 20px" v-if="activeRound === '2' || activeRound === '3'">
                <span style="margin-right: 12px">比赛轮次类型：</span>
                <el-select v-model="endState" placeholder="请选择比赛轮次类型" style="width: 180px; text-align: left" :disabled="activeRound === '2'">
                    <el-option
                        :value="true"
                        label="最终一轮">
                    </el-option>
                    <el-option
                        :value="false"
                        label="非最终一轮">
                    </el-option>
                </el-select>
            </div>
            <div class="tip" v-if="activeRound === '1'">0分及以上晋级(全部晋级)</div>
            <div class="tip" v-if="activeRound === '2'">第一轮成绩+第二轮成绩 指定分数以上晋级</div>
            <div class="tip" v-if="activeRound === '3'">第一轮成绩+第二轮成绩+第三轮成绩 指定分数以上晋级</div>
            <div class="tip" v-if="activeRound === '4'">第一轮成绩+第二轮成绩+第三轮成绩+第四轮成绩 指定分数以上晋级</div>
            <div style="text-align: center; margin-top: 40px">
                <el-button type="primary" @click="settingFn"
                    >确认设置</el-button
                >
            </div>
        </el-dialog>
        <!-- 查看晋级信息弹窗 -->
        <el-dialog
            title="晋级信息详情"
            :visible.sync="roundInfoDialogVisible"
            width="60%"
            @close="handleCloseRoundInfoDialog"
        >
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="roundInfoList"
                border
                stripe
            >
                <el-table-column
                    label="序号"
                    type="index"
                    width="50px"
                ></el-table-column>
                <el-table-column label="第几轮" prop="phase">
                    <template slot-scope="scope">
                        {{ scope.row.phase || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="分数" prop="scores">
                    <template slot-scope="scope">
                        {{ scope.row.scores ?? "-" }}
                    </template>
                </el-table-column>

                <el-table-column label="晋级状态" prop="promotion">
                    <template slot-scope="scope">
                        <el-tag
                            type="success"
                            v-if="scope.row.promotion === 1"
                            size="mini"
                            >晋级</el-tag
                        >
                        <el-tag type="danger" v-else size="mini">未晋级</el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="80px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="editRoundInfo(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column> -->
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="roundInfoDialogVisible = false"
                    >关 闭</el-button
                >
            </span>
        </el-dialog>
        <!-- 修改晋级信息弹窗 -->
        <el-dialog
            title="修改晋级信息"
            :visible.sync="editRoundInfoDialogVisible"
            width="40%"
            @close="handleCloseEditRoundInfoDialog"
        >
            <el-form
                :model="editRoundInfoForm"
                label-width="100px"
                ref="editRoundInfoFormRef"
                :rules="editRoundInfoFormRules"
            >
                <el-form-item label="第几轮" prop="phase">
                    <el-input
                        v-model="editRoundInfoForm.phase"
                        placeholder="请输入"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="分数" prop="scores">
                    <el-input-number
                        v-model="editRoundInfoForm.scores"
                        :min="0"
                        placeholder="请输入分数"
                        style="width: 100%"
                    ></el-input-number>
                </el-form-item>
                <el-form-item label="晋级状态" prop="promotion">
                    <el-select
                        v-model="editRoundInfoForm.promotion"
                        placeholder="请选择晋级状态"
                        style="width: 100%"
                    >
                        <el-option label="晋级" :value="1"></el-option>
                        <el-option label="未晋级" :value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editRoundInfoDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="saveRoundInfoData"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 手机号添加考生弹窗 -->
        <el-dialog
            title="手机号添加考生"
            :visible.sync="phoneAddDialogVisible"
            width="40%"
            @close="handleClosePhoneAddDialog"
        >
            <el-form
                :model="phoneAddForm"
                label-width="80px"
                ref="phoneAddFormRef"
                :rules="phoneAddFormRules"
            >
                <el-form-item label="手机号" prop="phones">
                    <el-input
                        v-model="phoneAddForm.phones"
                        type="textarea"
                        :rows="4"
                        placeholder="多个手机号使用英文逗号','隔开"
                        style="width: 100%"
                    ></el-input>
                    <div style="margin-top: 8px; color: red; font-size: 14px;">
                        填写示例：13111111111,13122222222
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="phoneAddDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="handlePhoneAdd"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 设置本轮晋级弹窗 -->
        <el-dialog
            title="设置本轮晋级"
            :visible.sync="roundPromotionDialogVisible"
            width="30%"
            @close="handleCloseRoundPromotionDialog"
        >
            <el-form
                :model="roundPromotionForm"
                label-width="100px"
                ref="roundPromotionFormRef"
                :rules="roundPromotionFormRules"
            >
                <el-form-item label="姓名" prop="examinationUserName">
                    <el-input
                        v-model="roundPromotionForm.examinationUserName"
                        placeholder="请输入"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="晋级状态" prop="promotion">
                    <el-select v-model="roundPromotionForm.promotion" placeholder="请选择晋级状态" style="width: 100%">
                        <el-option label="未设置" :value="0"></el-option>
                        <el-option label="晋级" :value="1"></el-option>
                        <el-option label="未晋级" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="tip">
              设置晋级状态为“晋级”时，第一/二/三轮分别晋级至下一轮，第四轮晋级至全球总决选。
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="roundPromotionDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveRoundPromotionData">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 未找到手机号弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="notFoundPhonesDialogVisible"
            width="40%"
            :close-on-click-modal="false"
        >
            <div style="text-align: center; padding: 20px 0;">
                <i class="el-icon-warning" style="color: #E6A23C; font-size: 48px; margin-bottom: 16px;"></i>
                <p style="font-size: 16px; color: #303133; margin-bottom: 16px;">以下手机号未找到对应考生：</p>
                <div style="background: #f5f7fa; padding: 16px; border-radius: 4px; max-height: 200px; overflow-y: auto;">
                    <p style="color: #606266; line-height: 1.6; margin: 0;">{{ notFoundPhones.join(', ') }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="notFoundPhonesDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import env from '@/http/env'
import { queryExaminationUserListPage, setTbEnrollmentPromotion, resetAllUser, resetSingleUser, queryUnselectedRoomUserList, batchExaminationRoom, setTbEnrollmentRoundPromotion } from '@/http/api'
export default {
  data () {
    return {
      editScoreDialogVisible: false,
      editScoreFormRules: {
        promotion: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      editScoreForm: {
        activityType: this.$chnEngStatusCode.activityType,
        raceSchedule: '2',
        season: this.$chnEngStatusCode.defaultSeason,
        userId: '',
        promotion: null
      },
      dataList: [],
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        examinationId: this.$route.query.id,
        userName: '',
        phone: '',
        schoolName: '',
        sign: null, // 是否签到
        raceSchedule: '2', // 复赛
        scoreValid: false,
        phase: '1' // 当前轮次
      },
      dict_group: this.$userInfo.dict_group(),
      dict_grade: this.$userInfo.getGradeData(),
      stuVisible: false,
      stuList: [],
      isOnline: this.$route.query.isOnline === '1', // 是否线上赛
      addQueryForm: {
        raceSchedule: '2', // 复赛
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$route.query.season,
        enrollmentLevel: this.$route.query.rl,
        roomType: this.$route.query.rt,
        districtId: ''
      },
      userIds: [],
      visible: false,
      endState: true,
      score: 100,
      roundInfoDialogVisible: false,
      roundInfoList: [],
      editRoundInfoDialogVisible: false,
      editRoundInfoFormRules: {
        scores: [{ required: true, message: '请输入分数', trigger: 'blur' }],
        promotion: [{ required: true, message: '请选择晋级状态', trigger: 'change' }]
      },
      editRoundInfoForm: {
        id: '',
        phase: '',
        scores: null,
        promotion: null
      },
      phoneAddDialogVisible: false,
      phoneAddForm: {
        phones: ''
      },
      phoneAddFormRules: {
        phones: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },
      // 未找到手机号弹窗
      notFoundPhonesDialogVisible: false,
      notFoundPhones: [],
      activeRound: '0', // 当前选中的轮次
      roundPromotionDialogVisible: false,
      roundPromotionForm: {
        id: '',
        examinationUserName: '',
        promotion: null
      },
      roundPromotionFormRules: {
        promotion: [{ required: true, message: '请选择晋级状态', trigger: 'change' }]
      },
      isShowScore: false // 是否显示分数列
    }
  },
  created () {
    this.addQueryForm.districtId = this.$route.query.districtId
    this.endState = !!(this.addQueryForm.roomType === 1 || this.addQueryForm.roomType === '1') // 北京赛区和上海赛区的复赛是最终一轮
    // 获取是否显示分数参数
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    handleToSearch () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleToReset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    async getList () {
      // 根据轮次选择不同的接口
      if (this.activeRound === '1') {
        // 第一轮使用原接口
        queryExaminationUserListPage(this.queryForm).then(res => {
          this.dataList = res.data.list
          this.total = res.data.total
        })
      } else if (this.activeRound === '2' || this.activeRound === '3' || this.activeRound === '4') {
        // 第二轮和第三轮使用新接口
        this.$http.get('examinationUser/queryUsersByRound', {
          params: this.queryForm
        }).then(res => {
          if (res.code === 200) {
            this.dataList = res.data.list
            this.total = res.data.total
          }
        })
      } else {
        // 选手管理使用原接口
        queryExaminationUserListPage(this.queryForm).then(res => {
          this.dataList = res.data.list
          this.total = res.data.total
        })
      }
    },
    getExamQuestion () {
      if (this.activeRound === '1') {
        // 第一轮使用原接口
        this.$http.post('examinationUser/copyRoundOneGroupForm', {
          id: this.queryForm.examinationId,
          phase: this.activeRound
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('第一轮考题已生成')
          }
        })
      } else if (this.activeRound === '2' || this.activeRound === '3' || this.activeRound === '4') {
      // 第二轮
        this.$http.post('examination/copyRoundTwoGroupForm', {
          id: this.queryForm.examinationId,
          phase: this.activeRound
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('考题已生成')
          }
        })
      }
    },
    // 跳转裁判系统
    turnToDetails () {
      this.$router.push({
        path: '/academic_Management/rm',
        query: {
          id: this.queryForm.examinationId, // 考试id
          r: this.queryForm.raceSchedule, // 赛程-复赛
          d: this.addQueryForm.districtId, // 赛区
          s: this.addQueryForm.season, // 赛季
          group: '3',
          phase: this.activeRound
        }
      })
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    async showEditDialog (row) {
      this.$confirm('是否重置该学生?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        resetSingleUser(row.id).then(res => {
          this.$message.success('已重置')
          this.handleToSearch()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      })
    },
    showMaskFn () {
      this.visible = true
      this.endState = this.activeRound === '4'
    },
    resetAllFn () {
      this.$confirm('是否将考场内全部选手移出考场?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        resetAllUser(this.queryForm.examinationId).then(res => {
          this.$message.success('已全部重置')
          this.handleToSearch()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      })
    },
    levelFormat (row) {
      const level = row.examinationUserLevel || row.enrollmentLevel
      return level ? this.dict_group.find(item => Number(item.dictValue) === level).dictLabel : '-'
    },
    gradeFormat (row) {
      const grade = row.examinationUserGrade || row.grade
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '-'
    },
    handleToSubmit () {
      this.$refs.dataFormRef.validate(async valid => {
        if (!valid) return false
        delete this.dataForm.dateRange
        const { data: res } = this.editType === 0 ? await this.$http.post('erp/nascc/certificate/create', this.dataForm) : await this.$http.put(`erp/nascc/certificate/edit/${this.editId}`, this.dataForm)
        if (res.code !== 0) {
          this.$message.error(res.message)
        } else {
          this.$message.success('保存成功')
          this.handleCloseDialog()
          this.getList()
        }
      })
    },
    handleToDetails (row) {
      this.$router.push({
        path: '/match_thing_manage/sspcn/certificateDetails',
        query: {
          id: row.id
        }
      })
    },
    daterangeChange (e) {
      if (e.length === 2) {
        this.dataForm.beginTime = e[0]
        this.dataForm.endTime = e[1]
      }
    },
    showStudents () {
      // 调接口
      queryUnselectedRoomUserList(this.addQueryForm).then(res => {
        this.stuList = res.data
        this.stuVisible = true
      })
    },
    handleCloseDialog () {
      this.stuVisible = false
    },
    handleSelectionChange (arr) {
      // console.log(arr)
      this.userIds = arr.map(item => item.userId)
    },
    handleToAdd () {
      batchExaminationRoom({
        activityType: this.addQueryForm.activityType,
        id: this.queryForm.examinationId,
        season: this.addQueryForm.season,
        userId: this.userIds
      }).then(res => {
        this.$message.success('添加成功')
        this.handleCloseDialog()
        this.handleToSearch()
      })
    },
    // 显示修改晋级弹窗
    scoreEditDialog (row) {
      console.log('row', row)
      this.editScoreForm.userName = this.editScoreForm.examinationUserName = row.examinationUserName ? row.examinationUserName : row.scoreName
      this.editScoreForm.raceSchedule = this.addQueryForm.raceSchedule
      this.editScoreForm.userId = row.userId ? row.userId : row.id
      this.editScoreDialogVisible = true
    },
    scoreRoundEditDialog (row) {
      // 检查是否有轮次信息，如果没有则直接返回
      // if (!this.hasRoundInfo(row)) {
      //   return
      // }
      console.log('row===========', row)
      if (row.tbEnrollmentRoundInfos && row.tbEnrollmentRoundInfos.length > 0) {
        this.roundPromotionForm.id = row.tbEnrollmentRoundInfos[0].id
      } else {
        this.roundPromotionForm.id = ''
      }
      this.roundPromotionForm.isGroup = 1
      this.roundPromotionForm.level = row.examinationUserLevel
      this.roundPromotionForm.examinationUserName = row.examinationUserName || row.scoreName
      this.roundPromotionForm.promotion = null
      this.roundPromotionForm.phase = Number(this.activeRound)
      this.roundPromotionForm.userId = row.userId ? row.userId : row.id
      this.roundPromotionForm.raceScheduleType = this.queryForm.raceSchedule
      this.roundPromotionForm.season = this.$chnEngStatusCode.defaultSeason
      this.roundPromotionForm.enrollmentId = row.enrollmentId
      this.roundPromotionForm.dataExaminationRoomId = row.examinationId
      this.roundPromotionForm.number = row.examinationNumber
      this.roundPromotionDialogVisible = true
    },
    // 修改成绩弹窗关闭
    editScoreDialogClose () {
      this.$refs.editScoreFormRef.resetFields()
    },
    // 提交线上成绩
    async savePromotionInfoData () {
      console.log('formData', this.editScoreForm)
      if (this.activeRound === '0') {
        setTbEnrollmentPromotion(this.editScoreForm).then((res) => {
          this.editScoreDialogVisible = false
          this.$message.success('修改成功')
          this.getList()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      } else {
        setTbEnrollmentRoundPromotion(this.editScoreForm).then((res) => {
          this.editScoreDialogVisible = false
          this.$message.success('修改成功')
          this.getList()
        })
      }
    },
    checkChange () {
      console.log(this.queryForm.scoreValid)
      this.queryForm.pageSize = this.queryForm.scoreValid ? 80 : 10
      this.getList()
    },
    handleCloseDialogSet () {
      this.visible = false
    },
    settingFn () {
      this.$confirm('确认设置该晋级分数线' + (this.activeRound === '2' ? '以及比赛是否是最终一轮么?' : '?'), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.activeRound === '1') {
          this.$http.post('examinationUser/setPromotionBatch', { examinationId: this.$route.query.id, score: this.score }).then(res => {
            if (res.code === 200) {
              this.visible = false
              this.$message.success('设置晋级成功')
              this.handleToSearch()
            }
          })
        } else if (this.activeRound === '2' || this.activeRound === '3' || this.activeRound === '4') {
          this.$http.post('examinationUser/setPromotionBatchRoundTwo', { examinationId: this.$route.query.id, score: this.score, phase: this.queryForm.phase, endState: this.endState }).then(res => {
            if (res.code === 200) {
              this.visible = false
              this.$message.success('设置晋级成功')
              this.handleToSearch()
            }
          })
        }
      }).catch(() => {
        // 用户取消操作
      })
    },
    showRoundInfoDialog (row) {
      if (row.tbEnrollmentRoundInfos && row.tbEnrollmentRoundInfos.length > 0) {
        this.roundInfoList = row.tbEnrollmentRoundInfos
        this.roundInfoDialogVisible = true
      } else {
        this.$message.info('暂无晋级信息')
      }
    },
    handleCloseRoundInfoDialog () {
      this.roundInfoDialogVisible = false
      this.roundInfoList = []
    },
    // 显示修改晋级信息弹窗
    editRoundInfo (row) {
      console.log('row', row)
      this.editRoundInfoForm.id = row.id
      this.editRoundInfoForm.phase = Number(this.activeRound)
      this.editRoundInfoForm.scores = row.scores
      this.editRoundInfoForm.promotion = row.promotion
      this.editRoundInfoDialogVisible = true
    },
    // 关闭修改晋级信息弹窗
    handleCloseEditRoundInfoDialog () {
      this.$refs.editRoundInfoFormRef.resetFields()
      this.editRoundInfoForm = {
        id: '',
        phase: '',
        scores: null,
        promotion: null
      }
    },
    // 保存修改的晋级信息
    saveRoundInfoData () {
      this.$refs.editRoundInfoFormRef.validate(async valid => {
        if (!valid) return false
        this.$message.error('等待接口')
        // try {
        //   const res = await this.$http.post('examinationUser/updateRoundInfo', {
        //     id: this.editRoundInfoForm.id,
        //     scores: this.editRoundInfoForm.scores,
        //     promotion: this.editRoundInfoForm.promotion
        //   })

        //   if (res.code === 200) {
        //     this.$message.success('修改成功')
        //     this.editRoundInfoDialogVisible = false
        //     // 更新当前列表中的数据
        //     const index = this.roundInfoList.findIndex(item => item.id === this.editRoundInfoForm.id)
        //     if (index !== -1) {
        //       this.roundInfoList[index].scores = this.editRoundInfoForm.scores
        //       this.roundInfoList[index].promotion = this.editRoundInfoForm.promotion
        //     }
        //   } else {
        //     this.$message.error(res.message || '修改失败')
        //   }
        // } catch (error) {
        //   console.error('修改晋级信息失败:', error)
        //   this.$message.error('修改失败')
        // }
      })
    },
    showPhoneAddDialog () {
      this.phoneAddDialogVisible = true
      this.$nextTick(() => {
        this.$refs.phoneAddFormRef.resetFields()
      })
    },
    handleClosePhoneAddDialog () {
      this.phoneAddDialogVisible = false
    },
    handlePhoneAdd () {
      this.$refs.phoneAddFormRef.validate(async valid => {
        if (!valid) return false
        const phones = this.phoneAddForm.phones.split(',').map(item => item.trim())
        if (phones.length === 0) {
          this.$message.warning('请输入手机号')
          return
        }
        const data = {
          id: this.queryForm.examinationId,
          phones: phones,
          raceSchedule: this.addQueryForm.raceSchedule
        }
        this.$http.post('examinationUser/batchExaminationRoomByPhones', data).then(res => {
          if (res.code === 200) {
            this.phoneAddDialogVisible = false
            this.getList()
            if (res.data && res.data.length > 0) {
              // 弹窗显示未找到的手机号
              this.notFoundPhones = res.data
              this.notFoundPhonesDialogVisible = true
            } else {
              this.$message.success('添加成功')
            }
          }
        })
      })
    },
    // 轮次切换
    handleTabClick (tab) {
      this.activeRound = tab.paneName
      this.queryForm.phase = tab.paneName
      this.queryForm.pageNum = 1

      // 设置分数显示状态
      if (this.activeRound === '0') {
        this.isShowScore = false // 选手管理不显示分数列
      } else {
        this.isShowScore = true // 第一轮、第二轮、第三轮显示分数列
      }

      // 重置筛选条件
      this.queryForm.userName = ''
      this.queryForm.phone = ''
      this.queryForm.schoolName = ''
      this.queryForm.scoreValid = false

      this.getList()
    },
    // 获取当前轮次的晋级状态
    getCurrentRoundPromotion (row) {
      if (row.tbEnrollmentRoundInfos && row.tbEnrollmentRoundInfos.length > 0) {
        // 根据当前选中的轮次查找对应的晋级信息
        const currentRoundInfo = row.tbEnrollmentRoundInfos[0]
        // console.log('currentRoundInfo', currentRoundInfo)
        return currentRoundInfo ? currentRoundInfo.promotion : null
      }
      return null
    },
    // 检查是否有轮次信息
    hasRoundInfo (row) {
      return row.tbEnrollmentRoundInfos && row.tbEnrollmentRoundInfos.length > 0
    },
    exportTable () {
      // 根据轮次选择不同的导出接口
      let downLoadUrl
      if (this.activeRound === '1') {
        // 第一轮使用原导出接口
        downLoadUrl = env.baseIP + 'examinationUser/exprotExaminationUserListPage'
      } else if (this.activeRound === '2' || this.activeRound === '3' || this.activeRound === '4') {
        // 第二轮和第三轮使用新导出接口
        downLoadUrl = env.baseIP + 'examinationUser/exportUsersByRound'
      } else {
        // 选手管理使用原导出接口
        downLoadUrl = env.baseIP + 'examinationUser/exprotExaminationUserListPage'
      }
      this.$downLoadFile.downLoadFileWithUrlNew(this, downLoadUrl, this.queryForm)
    },
    // 关闭设置本轮晋级弹窗
    handleCloseRoundPromotionDialog () {
      this.$refs.roundPromotionFormRef.resetFields()
      this.roundPromotionForm = {
        id: '',
        examinationUserName: '',
        promotion: null
      }
    },
    // 保存本轮晋级数据
    saveRoundPromotionData () {
      this.$refs.roundPromotionFormRef.validate(async valid => {
        if (!valid) return false
        setTbEnrollmentRoundPromotion(this.roundPromotionForm).then(res => {
          this.$message.success('设置成功')
          this.roundPromotionDialogVisible = false
          this.getList()
        }).catch(err => {
          console.log('设置失败', err)
          this.$message.error('设置失败')
        })
      })
    },
    // 处理签到状态变化
    handleSignChange (row) {
      this.$http.post('examinationUser/sign', {
        id: row.id,
        sign: row.sign
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(row.sign ? '签到成功' : '取消签到成功')
        } else {
          // 如果请求失败，恢复原状态
          row.sign = !row.sign
          this.$message.error(res.message || '操作失败')
        }
      }).catch(err => {
        // 如果请求失败，恢复原状态
        row.sign = !row.sign
        console.log('签到操作失败', err)
        this.$message.error('操作失败')
      })
    },
    turnAnswerResult (rowData) {
      if (this.activeRound === '1') {
        console.log('rowData', rowData)
        if (!rowData.formQuizMatchResultId) {
          this.$message.warning('暂无答题详情')
          return
        }
        var formData = {
          season: this.$chnEngStatusCode.defaultSeason,
          activityType: this.$chnEngStatusCode.activityType,
          raceSchedule: this.queryForm.raceSchedule,
          userId: rowData.userId
        }
        var formData2 = {
          matchResultId: rowData.formQuizMatchResultId,
          season: this.$chnEngStatusCode.defaultSeason,
          userName: rowData.examinationUserName,
          score: rowData.score,
          activeRound: this.activeRound,
          phase: this.queryForm.phase,
          raceSchedule: this.queryForm.raceSchedule,
          userId: rowData.userId,
          id: this.queryForm.examinationId
        }
        this.$router.push(
          {
            path: '/schedule_Childview/individual_answer_result',
            query: {
              formDataStr: this.$chnEngStatusCode.defaultSeason === '2022~2023' ? JSON.stringify(formData) : JSON.stringify(formData2)
            }
          }
        )
      } else if (this.activeRound === '2' || this.activeRound === '3' || this.activeRound === '4') {
        var formData3 = {
          matchResultId: rowData.formGroupMatchResultId,
          season: this.$chnEngStatusCode.defaultSeason,
          userName: rowData.examinationUserName,
          score: rowData.score,
          activeRound: this.activeRound,
          phase: this.queryForm.phase,
          raceSchedule: this.queryForm.raceSchedule,
          userId: rowData.userId,
          id: this.queryForm.examinationId
        }
        this.$router.push(
          {
            path: '/schedule_Childview/individual_answer_result',
            query: {
              formDataStr: JSON.stringify(formData3)
            }
          }
        )
      }
    }
  }
}
</script>
<style lang="less" scoped>
.div_algin_right {
    text-align: right;
}

.tip{
  color: #F56C6C;
  font-size: 12px;
  width: 90%;
  margin: 20px auto;
  text-align: center;
}

// 轮次tab样式优化
.round-tabs {
    .el-tabs__header {
        margin-bottom: 0;
        border-bottom: none;
    }

    .el-tabs__nav-wrap {
        padding: 0 20px;
    }

    .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: 500;
        color: #606266;
        border: 1px solid #e4e7ed;
        border-radius: 8px 8px 0 0;
        margin-right: 8px;
        transition: all 0.3s ease;

        &:hover {
            color: #409eff;
            background-color: #f5f7fa;
        }

        &.is-active {
            color: #fff;
            background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%);
            border-color: #409eff;
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }

        i {
            margin-right: 8px;
            font-size: 18px;
        }
    }

    .el-tabs__content {
        padding: 20px;
        background: #fafafa;
        border-radius: 0 0 8px 8px;
        min-height: 60px;
    }
}

// 卡片样式优化
.el-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: none;

    .el-card__body {
        padding: 20px;
    }
}

// 标题行样式
.title_row {
    margin-bottom: 20px;

    .title_class {
        font-size: 16px;
        // font-weight: 600;
        color: #303133;
        position: relative;
        padding-left: 12px;

        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 18px;
            background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%);
            border-radius: 2px;
        }
    }
}
</style>
